import ProductDetail from './ProductDetail';
import MockupTienda360 from '../components/products/MockupTienda360';

const ProductTienda360 = () => (
  <ProductDetail productId='tienda360' Mockup={MockupTienda360} />
);

export default ProductTienda360;
